export default "__VITE_ASSET__CHamsN5b__"